if (!document.getElementById("applicant-form")) return;

// Setup modal
const modal = document.querySelector('.custom-message-modal-overlay');
const modalTitle = document.querySelector('.custom-message-modal-title');
const modalBodyText = document.querySelector('.custom-message-modal-body');
const modalFooter = document.querySelector('.custom-message-modal-footer');
const modalTriggerBtn = document.querySelector('.open-modal-btn');

// Click outside to close modal (optional)
// if (modal) {
//     modal.addEventListener('click', function(e) {
//         if (e.target.classList.contains('custom-message-modal-overlay') || e.target.classList.contains('job-apply')) {
//             modal.classList.remove('d-flex');
//             if (modalFooter) modalFooter.innerHTML = '';
//         }
//     });
// }

// Function to show modal message without OK button
function employeeApplyJobModal(message, title='Attention required') {
    if (modalTitle) modalTitle.innerHTML = title;
    if (modalBodyText) modalBodyText.innerHTML = '';
    if (modalBodyText) modalBodyText.innerHTML = message;

    const modalElement = document.querySelector('.custom-message-modal-overlay');
    if( modalElement ) modalElement.classList.add('processing');
    const modalCross = document.querySelector('.custom-message-modal-close');
    if( modalCross ) modalCross.style.display = 'none';

    const confirmButton = document.createElement('button');
    confirmButton.className = 'custom-message-modal-btn btn btn-primary btn-xs job-apply';
    confirmButton.textContent = 'Ok';

    if (modalTitle) modalTitle.innerHTML = title;

    if (modalFooter) modalFooter.innerHTML = '';
    if (modalFooter) modalFooter.appendChild(confirmButton);

    // Show modal
    if (modalTriggerBtn) modalTriggerBtn.click();
}

// Form submission handler
const employerApplicantForm = document.getElementById("applicant-form");
employerApplicantForm.addEventListener("submit", function(event) {
    event.preventDefault();
    
    const firstName = document.getElementById("firstName").value.trim();
    const lastName = document.getElementById("lastName").value.trim();
    const contactNumber = document.getElementById("contactNumber").value.trim();
    const uploadedResume = document.getElementById("uploaded-resume").value;
    const uploadedCV = document.getElementById("uploaded-cv").value;

    const errors = [];

    if( firstName == '' ) {
        errors.push({ message: 'First name is required', scrollDiv: '.job-application-form', attrId: 'firstName' });
    } else {
        const nameRegex = /^[a-zA-Z\s]{2,100}$/;
        if (!nameRegex.test(firstName)) {
            errors.push({ message: 'First name must include alphabets of 2-100 characters', scrollDiv: '.job-application-form', attrId: 'firstName' });
        }
    }
    if( lastName == '' ) {
        errors.push({ message: 'Last name is required', scrollDiv: '.job-application-form', attrId: 'lastName' });
    } else {
        const nameRegex = /^[a-zA-Z\s]{2,100}$/;
        if (!nameRegex.test(lastName)) {
            errors.push({ message: 'Last name must include alphabets of 2-100 characters', scrollDiv: '.job-application-form', attrId: 'lastName' });
        }
    }
    if (!/^\d{10}$/.test(contactNumber)) errors.push({ message: 'Enter a valid 10-digit phone number', scrollDiv: '.job-application-form', attrId: 'contactNumber' });

    if( uploadedResume != 1 ) {
        errors.push({ message: 'Please upload resume', scrollDiv: '#email', attrId: 'resume-file-upload' });
    }
    if( uploadedCV != 1 ) {
        errors.push({ message: 'Please upload coverletter', scrollDiv: '#contactNumber', attrId: 'cv-file-upload' });
    }
    
    const errorElements = document.querySelectorAll('.err');
    if(errorElements) errorElements.forEach(el => el.remove());

    if (errors.length > 0) {
        errors.forEach(error => {
            const errID = document.getElementById(error.attrId);
            const errMessage = error.message;
            if (errID) {
                const p = document.createElement('p');
                p.className = 'err';
                p.textContent = errMessage;
                errID.after(p);
            }
        });

        // employeeApplyJobModal('<p>Please fill in all necessary details to proceed.</p>');

        const target = document.querySelector(errors[0].scrollDiv);
        if (target) target.scrollIntoView({ behavior: 'smooth' });
        return;
    }
    
    // -- license -- //
    // const licenseEntries = document.querySelectorAll(".drivers-license-wrap");
    // let licenseData = [];
    // licenseEntries.forEach(entry => {
    //     const name = entry.querySelector(".license-name").textContent.trim();
    //     const state = entry.querySelector(".license-state").textContent.trim();
    //     const number = entry.querySelector(".license-number").textContent.trim();
    //     const expiry = entry.querySelector(".license-expiry").textContent.trim();
    //
    //     licenseData.push({
    //         licenseName: name,
    //         licenseNo: number,
    //         licenseState: state,
    //         licenseExpiry: expiry
    //     });
    // });
    // if (licenseData.length === 0) {
    //     employeeApplyJobModal('<p>No license data found.</p>');
    //     const el = document.querySelector('.form-element--drivers-license');
    //     const p = document.createElement('p');
    //     p.className = 'err';
    //     p.textContent = 'No License data found';
    //     el.append(p);
    //     const offset = 100;
    //     const y = el.getBoundingClientRect().top + window.scrollY - offset;
    //     window.scrollTo({ top: y, behavior: 'smooth' });
    //     return;
    // }
    // --- license --- //
    
    // -- qualification -- //
    const qualificationEntries = document.querySelectorAll(".university-wrap");
    let qualificationData = [];
    qualificationEntries.forEach(entry => {
        const name = entry.querySelector(".course-name").textContent.trim();
        const place = entry.querySelector(".course-place").textContent.trim();
        const year = entry.querySelector(".course-year").textContent.trim();
        
        qualificationData.push({
            qualificationName: name,
            placeOfCompletion: place,
            yearOfCompletion: year,
        });
    });
    if (qualificationData.length === 0) {
        // employeeApplyJobModal('<p>No qualification data found.</p>');
        const el = document.querySelector('.form-element--qualification');
        const p = document.createElement('p');
        p.className = 'err';
        p.textContent = 'No qualification data found';
        el.append(p);
        const offset = 100;
        const y = el.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top: y, behavior: 'smooth' });
        return;
    }
    // --- qualification --- //

    // -- skills --//
    const skillElements = document.querySelectorAll('.skills-list-item input[type="text"]');
    let skillData = [];

    skillElements.forEach(el => {
        const skill = el.value.trim();
        if (skill) {
            skillData.push({ skill });
        }
    });
    if (skillData.length === 0) {
        // employeeApplyJobModal('<p>No skills entered.</p>');
        const el = document.querySelector('.form-element--skills');
        const p = document.createElement('p');
        p.className = 'err';
        p.textContent = 'No skills data found';
        el.append(p);
        const offset = 100;
        const y = el.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top: y, behavior: 'smooth' });

        return;
    }
    // --- skills --- //

    const formData = new FormData(employerApplicantForm);
    formData.append('action', 'employee_apply_for_job');
    formData.append('nonce', ajax_callback_data.ajax_nonce);
    formData.append('skills', JSON.stringify(skillData));
    // formData.append('license', JSON.stringify(licenseData));
    formData.append('qualification', JSON.stringify(qualificationData));

    employeeApplyJobModal('<p>Applying for job...</p>', 'Please wait');
    if (modalFooter) modalFooter.innerHTML = '';

    fetch(ajax_callback_data.ajax_url, {
        method: 'POST',
        body: formData
    })
    .then(res => res.json())
    .then(data => {
        if (data.success) {
            employeeApplyJobModal('<p>Applied for job successfully.</p>', 'Confirmation');
            if (modalFooter) modalFooter.innerHTML = '';
            document.querySelector('.job-application-form').scrollIntoView({ behavior: 'smooth' });
            window.location.reload();
        } else {
            const message = data?.data?.message || 'Something went wrong. Try again.';
            employeeApplyJobModal(`<p>${message}</p>`);
        }
    })
    .catch(() => {
        employeeApplyJobModal('<p>Something went wrong. Try again.</p>');
    });

});